<template>
    <div class="pd-t-10 pd-b-10 pd-l-20 pd-r-20">
        <div class="fz-12 lh-18 fw-4">{{data.title}}</div>
        <div class="hide-native-scroll search-suggestion-list">
            <SearchSuggestionTile
                v-for="item in data.list"
                :data="item"
                :key="item.id"
                class="item search-suggestion-item"
            >
            </SearchSuggestionTile>
        </div>
    </div>
</template>

<script>
    import SearchSuggestionTile from "@/components/SearchSuggestionTile.vue";
    export default {
        name : 'SearchSuggestionList',
        components : {
            SearchSuggestionTile : SearchSuggestionTile,
        },
        props : {
            data : Object
        },
        data : function () {
            return {}
        },
        methods : {

        }
    }
</script>

<style>

</style>